import { render, staticRenderFns } from "./ProductSettingPrice.vue?vue&type=template&id=a44ee8ea&"
import script from "./ProductSettingPrice.vue?vue&type=script&lang=js&"
export * from "./ProductSettingPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports